import { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Radio,
} from "@mui/material";
import { PrimaryButton, PrimaryButtonText } from "../../components/ui/Button";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES } from "../../routes/routerConfig";
import {
  setUserProfileData,
  authSelector,
} from "../../services/redux/slices/authSlice";
import { RadioButton } from "../../components/ui/RadioButton";
import { decrypt, encrypt, encryptObject } from "../../utils/crypto";
import { ReactComponent as UserIcon } from "../../assets/images/icons/userone.svg";
import { ReactComponent as UserIconTwo } from "../../assets/images/icons/usertwo.svg";
import service from "../../services/api/service";
import {
  setStatusPopup,
} from "../../services/redux/slices/statusPopupSlice";
import ButtonLoader from "../../components/ui/ButtonLoader";

type props = {
  setNextStep: (step: string) => void;
};

const SelectProfile = ({ setNextStep }: props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const registerKey = useSelector((state: any) => state.keyRegistrar.keys);
  const rawSignupOnboardApi = useSelector(
    (state: any) => state.keyRegistrar.signupOnboardApi
  );
  const [isLoading, setIsLoading] = useState(false);

  // If signupOnboardApi is a string, apply the .replace() transformation
  const signupOnboardApi =
    typeof rawSignupOnboardApi === "string"
      ? JSON.parse(rawSignupOnboardApi.replace(/([{,]\s*)(\w+):/g, '$1"$2":'))
      : rawSignupOnboardApi;
  const mobileNumbers = useSelector(
    (state: any) => state.keyRegistrar.mobileNumbers
  );
  const lanNumbers = useSelector((state: any) => state.keyRegistrar.lanNumbers);
  const [selectedProfileId, setSelectedProfileId] = useState<null | number>(
    null
  );
  const [selectedData, setSelectedData] = useState<null | string>(
    null
  );
  const { otpVerifyUsersData, userProfile } = useSelector(authSelector);


  const handleSelectProfile = (id: number | null) => {
    setIsLoading(true)
    const matchObject = signupOnboardApi.filter(
      (item: any) => item.custcif === String(selectedProfileId)
    );
    const signupOnboardPayload = {
      lan: encrypt(lanNumbers),
      key: encrypt(mobileNumbers),
      type: 1,
      custData: encryptObject(matchObject),
    };
    if (registerKey == "register") {
      service?.auth?.signupOnboard(signupOnboardPayload).then((res) => {
        setIsLoading(false)
        const otpVerifyUsersData = res?.data?.data;
        if (otpVerifyUsersData?.length === 1) {
          dispatch(setUserProfileData(otpVerifyUsersData[0]));
          if (otpVerifyUsersData[0]?.isVerified) {
            setNextStep(ROUTES?.Login?.thankYouPage?.path);
          } else {
            setNextStep(ROUTES?.Login?.thankYouPage?.path);
          }
        } else {
          setNextStep(ROUTES?.Login?.thankYouPage?.path);
        }
      }).catch((error: any) => {
        setIsLoading(false)
        dispatch(
          setStatusPopup({
            status: "error",
            message: error.response.data.message,
          })
        );
      });;
    } else {
      const profile: any = otpVerifyUsersData?.find(
        (profile: any) => profile?.id === id
      );
      if (profile?.id) {
        dispatch(setUserProfileData(profile));
        if (profile?.isVerified) {
          // navigate(ROUTES?.Login?.enterPassword?.locationPath);
          setNextStep(ROUTES?.Login?.enterPassword?.path);
        } else {
          // navigate(ROUTES?.Login?.setPassword?.locationPath);
          setNextStep(ROUTES?.Login?.setPassword?.path);
        }
      }
    }
  };
  const handleBack = () => setNextStep("");

  return (
    <Box>
      <PrimaryButtonText
        startIcon={<ArrowBack color="inherit" fontSize="small" />}
        onClick={handleBack}
      >
        Back
      </PrimaryButtonText>

      <Box className="main-wrapper">
        <Box className="head-section">
          <Box className="heading_2">
            {registerKey === "register"
              ? "Please select preferred CIF number"
              : "Select CIF number"}
          </Box>
          <Box className="sub-heading">
            {registerKey === "register"
              ? "The following CIF number linked to your email/mobile number"
              : "We have found following CIF linked to your email and mobile number"}
          </Box>
        </Box>
        <List
          aria-label="profile list"
          style={{ width: "100%", padding: "0px !important" }}
        >
          {registerKey === "register" &&
            Array.isArray(signupOnboardApi) &&
            signupOnboardApi.length > 0 ? (
            signupOnboardApi.map((profile: any) => (
              <Box
                key={profile?.id}
                component="section"
                height="55px"
                my={1}
                pl={0}
                display="flex"
                alignItems="left"
                sx={{
                  border: "1px solid #1CB1B1",
                  borderRadius: "8px",
                  backgroundColor:
                    selectedProfileId === profile?.custcif
                      ? "#D3F8F8"
                      : "transparent",
                }}
              >
                {selectedProfileId === profile?.custcif ? (
                  <Box className="user-box">
                    <UserIcon />
                  </Box>
                ) : (
                  <Box className="user-box-two">
                    <UserIconTwo />
                  </Box>
                )}
                <ListItem
                  button
                  onClick={() => { setSelectedProfileId(profile?.custcif); setSelectedData(profile) }}
                  sx={{ paddingRight: "0px" }}
                >
                  <ListItemText
                    className="text-lable"
                    primary={profile?.custfname}
                    secondary={profile?.custcif}
                    primaryTypographyProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "15px",
                      },
                    }}
                    secondaryTypographyProps={{
                      sx: {
                        fontSize: "15px",
                      },
                    }}
                  />
                  <ListItemIcon>
                    <RadioButton
                      checked={selectedProfileId === profile?.custcif}
                      onChange={() => setSelectedProfileId(profile?.custcif)}
                    />
                  </ListItemIcon>
                </ListItem>
              </Box>
            ))
          ) : (
            <>
              {otpVerifyUsersData?.length > 0 &&
                otpVerifyUsersData?.map((profile: any) => (
                  <Box
                    key={profile?.id}
                    component="section"
                    height="55px"
                    my={1}
                    pl={0}
                    display="flex"
                    alignItems="left"
                    sx={{
                      border: "1px solid #1CB1B1",
                      borderRadius: "8px",
                      backgroundColor:
                        selectedProfileId === profile?.id
                          ? "#D3F8F8"
                          : "transparent",
                    }}
                  >
                    {selectedProfileId === profile?.id ? (
                      <Box className="user-box">
                        <UserIcon />
                      </Box>
                    ) : (
                      <Box className="user-box-two">
                        <UserIconTwo />
                      </Box>
                    )}
                    <ListItem
                      button
                      onClick={() => setSelectedProfileId(profile?.id)}
                      sx={{ paddingRight: "0px" }}
                    >
                      <ListItemText
                        className="text-lable"
                        primary={profile?.name}
                        secondary={decrypt(profile?.cifNumber)}
                        primaryTypographyProps={{
                          sx: {
                            fontWeight: "bold",
                            fontSize: "15px",
                          },
                        }}
                        secondaryTypographyProps={{
                          sx: {
                            fontSize: "15px",
                          },
                        }}
                      />
                      <ListItemIcon>
                        <RadioButton
                          checked={selectedProfileId === profile?.id}
                          onChange={() => setSelectedProfileId(profile?.id)}
                        />
                      </ListItemIcon>
                    </ListItem>
                  </Box>
                ))}
            </>
          )}
        </List>

        <PrimaryButton
          type="button"
          onClick={() => handleSelectProfile(selectedProfileId)}
          fullWidth
          endIcon={!isLoading && <ArrowForward color="inherit" fontSize="small" />}
          disabled={!selectedProfileId || isLoading}
        >
          <ButtonLoader title="Continue" isLoading={isLoading} />
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default SelectProfile;
